export const LOADING_CONNECTIONS = 'connections/LOAD_CONNECTIONS'
export const LOADING_CONNECTIONS_SUCCESS = 'connections/LOAD_CONNECTIONS_SUCCESS'
export const LOADING_CONNECTIONS_FAILURE = 'connections/LOAD_CONNECTIONS_FAILURE'
